module.exports = __webpack_public_path__ + "static/2_launchInstance-720227b93bb176da9c687d8e0bc26071.jpg";